/*------------------------------------*\
	#TABS
\*------------------------------------*/

const selectorTabs = '.js-tabs-list',
	selectorListItems = '[data-tab-target]',
	selectorContentItems = '[data-tab-content]',
	selectorTabsIsActive = 'is-active';

const tabsContainer = document.querySelectorAll(selectorTabs);

const initTabs = () => {

	if (tabsContainer) {
		tabsContainer.forEach(tabContainer => {
			const tabListItems = tabContainer.querySelectorAll(selectorListItems);

			tabListItems.forEach(tabListItem => {
				tabListItem.addEventListener('click', () => {
					const contentFromCurrentTabContainer = tabContainer.nextElementSibling;
					const tabContentItems = contentFromCurrentTabContainer.querySelectorAll(selectorContentItems)
					const selectorTargetTabId = "[data-tab-id='" + tabListItem.dataset.tabTarget + "']";
					const targetContentItem = contentFromCurrentTabContainer.querySelector(selectorTargetTabId);

					// remove in all tab-list items the is-active class
					tabListItems.forEach(tabListItem => {
						tabListItem.classList.remove(selectorTabsIsActive)
					})

					// remove in all tab-content items the is-active class
					tabContentItems.forEach(tabContent => {
						tabContent.classList.remove(selectorTabsIsActive)
					})

					tabListItem.classList.add(selectorTabsIsActive)
					targetContentItem.classList.add(selectorTabsIsActive)

				})
			})
		})
	}
}

window.addEventListener('DOMContentLoaded', (event) => {
	initTabs();
});
